import React from 'react';
import { Box } from '@mui/material';

interface BackgroundWrapperProps {
  children: React.ReactNode;
  minHeight?: string;
}

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({ 
  children, 
  minHeight = "100vh" 
}) => {
  return (
    <Box
      sx={{
        minHeight,
        backgroundImage: "url(/home.jpeg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Dark overlay for better text readability
          zIndex: 1,
        },
      }}
    >
      <Box sx={{ position: "relative", zIndex: 2 }}>
        {children}
      </Box>
    </Box>
  );
};

export default BackgroundWrapper;
